import { Translation } from "./translation";
import { action, observable } from "mobx";
import dayjs from "dayjs";
import { DefaultLogger } from "../logger";

export class TranslationStoreFactory {
  private translations: { [key: string]: Translation } = {};

  @observable
  public activeLanguage = "en";

  @action
  public setActiveLanguage(lang: string) {
    this.activeLanguage = lang;
  }

  public getTranslations() {
    return this.translations;
  }

  public getTranslation = (key: string) => {
    let translation: Translation | undefined = this.translations[key];

    if (!translation) {
      translation = new Translation(key, key);
      this.translations[key] = translation;
    }

    return translation;
  };

  public resetTranslations = () => {
    for (const [key, value] of Object.entries(this.translations)) {
      value.setValue(key);
    }
  };

  @action
  public setTranslations = (translations: { [key: string]: string }) => {
    this.resetTranslations();
    for (const [key, value] of Object.entries(translations)) {
      const translation = this.getTranslation(key);
      translation.setValue(value);
    }
  };

  @action
  public setTokens = <I extends { [key: string]: string | Translation }>(
    tokens: I
  ) => {
    const returnTokens: { [key: string]: Translation } = {};
    for (const [key, value] of Object.entries(tokens)) {
      if (typeof value === "string") {
        returnTokens[key] = this.getTranslation(value);
      } else {
        returnTokens[key] = value;
      }
    }

    return returnTokens as { [key in keyof I]: Translation };
  };

  /**
   * Safely set locale of the moment passed in the first argument equal to the
   * currently
   */
  public localizedMoment(date: Date | string | undefined) {
    const localizedMoment = dayjs(date);
    try {
      localizedMoment.locale(this.activeLanguage);
    } catch (e) {
      DefaultLogger.captureException(e);
    }

    return localizedMoment;
  }
}

export const TranslationStore = new TranslationStoreFactory();
